import _ from 'lodash'

export default class SharedStore {

    constructor() {
        this.eventBus = document.createElement('bus')
        this.state = {}
    }

    addEventListener(event, callback) {
        this.eventBus.addEventListener(event, callback)
    }

    removeEventListener(event, callback) {
        this.eventBus.removeEventListener(event, callback);
    }

    dispatchEvent(event, detail = {}) {
        this.eventBus.dispatchEvent(new CustomEvent(event, {
            detail
        }));
    }

    get(property) {
        return _.get(this.state, property)
    }

    set(property, value) {
        _.set(this.state, property, value)
        this.dispatchEvent('changeState', {
            property: property,
            value: value
        })
    }

    onChange(property, callback) {
        this.addEventListener('changeState', (data) => {
            if (data.detail.property == property) {
                callback(data.detail.value)
            }
        })
    }
}